import React from 'react';
import { Link } from 'react-router-dom';
import img from '../../../assests/images/Images';

const SERVICES_DATA = [
  {
    title: 'Web & Custom App Development',
    desc: 'Scalable web apps, modern React/Next.js architectures, mobile & custom APIs.',
    to: '/services/web-development',
    image: img.customweb,
  },
  {
    title: 'Business Software Solutions',
    desc: 'Custom ERP, CRM, HRM & automated internal process management systems.',
    to: '/services/business-software',
    image: img.business,
  },
  {
    title: 'UI/UX & Product Design',
    desc: 'User flows, wireframing, design systems & intuitive product interfaces.',
    to: '/services/ui-ux-design',
    image: img.uiux,
  },
  {
    title: 'Cloud & DevOps',
    desc: 'Automated CI/CD pipelines, AWS/Azure cloud infrastructure & 24/7 reliability.',
    to: '/services/cloud-devops',
    image: img.devops,
  },
  {
    title: 'Digital Marketing',
    desc: 'SEO optimization, content strategy, performance marketing & lead generation.',
    to: '/services/digital-marketing',
    image: img.digital,
  },
];

const ServicesDropdown = ({ closeMenu, handleMouseEnter, handleMouseLeave }) => {
  return (
    <div
      className="sipl-mega-dropdown-menu rounded-2xl bg-white shadow-2xl p-4 p-md-5"
      style={{
        position: 'absolute',
        top: 'calc(100% + 12px)',
        left: '-40px',
        width: '720px',
        maxWidth: '92vw',
        backgroundColor: '#ffffff',
        border: '1px solid #e2e8f0',
        borderRadius: '1rem',
        boxShadow: '0 25px 60px -15px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(226, 232, 240, 0.9)',
        zIndex: 9999,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Header Bar */}
      <div className="d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom" style={{ borderColor: '#f1f5f9' }}>
        <div className="d-flex align-items-center gap-2">
          {/* Logo Color Accent Dots */}
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1a2f6e', display: 'inline-block' }}></span>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#0d9488', display: 'inline-block' }}></span>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#4caf50', display: 'inline-block' }}></span>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#f97316', display: 'inline-block' }}></span>
          <span
            className="text-uppercase font-mono font-bold tracking-widest ms-1"
            style={{ fontSize: '11px', letterSpacing: '0.1em', color: '#1a2f6e', fontWeight: 800 }}
          >
            CORE SERVICES & CAPABILITIES
          </span>
        </div>
      </div>

      {/* Bootstrap 2-Column Grid */}
      <div className="row g-3">
        {SERVICES_DATA.map((sub) => (
          <div className="col-12 col-md-6" key={sub.title}>
            <Link
              to={sub.to}
              onClick={closeMenu}
              className="sipl-service-item d-flex align-items-start gap-3 p-2.5 rounded-xl text-decoration-none transition-colors"
              style={{ textDecoration: 'none', color: '#0f172a' }}
            >
              {/* 3D Illustration Real Image Badge Box */}
              <div
                className="sipl-service-img-box d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: '46px',
                  height: '46px',
                  minWidth: '46px',
                  minHeight: '46px',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 2px 6px rgba(15, 23, 42, 0.05)',
                  overflow: 'hidden',
                  padding: '3px',
                }}
              >
                <img
                  src={sub.image}
                  alt={sub.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    display: 'block',
                  }}
                  loading="lazy"
                  decoding="async"
                />
              </div>

              <div className="flex-grow-1">
                <div
                  className="sipl-service-title text-sm font-bold text-slate-900 leading-tight"
                  style={{ color: '#0f172a', fontWeight: 700, fontSize: '0.875rem', lineHeight: '1.25' }}
                >
                  {sub.title}
                </div>
                <div
                  className="text-xs text-slate-500 font-normal leading-relaxed mt-1"
                  style={{ color: '#64748b', fontSize: '0.75rem', fontWeight: 400, lineHeight: '1.4' }}
                >
                  {sub.desc}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Footer Strip */}
      <div className="mt-4 pt-3 border-top d-flex align-items-center justify-content-between text-xs p-3 rounded-3" style={{ borderColor: '#f1f5f9', backgroundColor: '#f8fafc' }}>
        <div className="d-flex align-items-center gap-2">
          <span className="font-semibold text-slate-700" style={{ color: '#334155', fontWeight: 600, fontSize: '0.82rem' }}>
            Need custom technology solutions?
          </span>
        </div>
        <Link
          to="/contact"
          onClick={closeMenu}
          style={{ color: '#0d9488', fontWeight: 700, textDecoration: 'none', fontSize: '0.82rem' }}
        >
          Talk to an Expert →
        </Link>
      </div>
    </div>
  );
};

export default ServicesDropdown;
